// extracted by mini-css-extract-plugin
module.exports = {"title":"_3gw7l___Listings-module__title","cardList":"_2GKCk___Listings-module__cardList"};